import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProfileNavDropdown.css';

function ProfileNavDropdown({ user, rider, onLogout }) {
  const [copied, setCopied] = useState(false);
  if (!user) return null;

  const handleShare = () => {
    // This would ideally use a dynamic referral code from the rider object
    const referralCode = "CD-EMMAXG3";
    const referralLink = `https://www.9troride.com/signup?ref=${referralCode}`;
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="profile-nav-dropdown">
      <div className="profile-nav-dropdown-header">
        <strong>{rider?.first_name && rider?.last_name ? `${rider.first_name} ${rider.last_name}` : (user.displayName || 'Rider')}</strong>
        <span>{user.email}</span>
        {rider?.phoneNumber && <span className="phone-number">{rider.phoneNumber}</span>}
      </div>
      <div className="profile-nav-dropdown-section">
        <div className="profile-nav-rewards">
          <div className="rewards-header">
            <span className="rewards-title">Starters</span>
          </div>
          <p className="rewards-description">Rack up more points to enjoy monthly goodies!</p>
          <ul className="rewards-list">
            <li className="reward-item">
              <div className="item-icon-left">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
              </div>
              <span>₦500 off 2 orders.</span>
            </li>
            <li className="reward-item">
              <div className="item-icon-left">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 21h4"/><path d="M8 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path d="M16 17.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/><path d="M2 9h1.36a2 2 0 0 1 1.9 1.45l1.17 4.1 4.37.87c.33.07.67.07.99 0l4.37-.87 1.17-4.1a2 2 0 0 1 1.9-1.45H22"/></svg>
              </div>
              <span>2 free deliveries.</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="profile-nav-dropdown-section">
        <Link to="/favorites" className="profile-nav-dropdown-item">
          <div className="item-icon-left">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </div>
          <span>View Favorites</span>
          <div className="item-icon-right">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </Link>
        <Link to="/orders" className="profile-nav-dropdown-item">
          <div className="item-icon-left">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          </div>
          <span>Order History</span>
          <div className="item-icon-right">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </Link>
      </div>
      <div className="profile-nav-dropdown-section">
        <div className="profile-nav-referral">
          <span className="referral-title">Refer & Earn</span>
          <p className="referral-description">Get ₦1,000 on their first 2 orders!</p>
          <div className="referral-code-wrapper">
            <span className="referral-code">CD-EMMAXG3</span>
            <button className="share-btn" onClick={handleShare}>
              {copied ? <span className="copied-text">Copied!</span> : <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>}
            </button>
          </div>
        </div>
      </div>
      <div className="profile-nav-dropdown-section">
        <Link to="/support" className="profile-nav-dropdown-item">
          <div className="item-icon-left">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          </div>
          <span>Reach Support</span>
          <div className="item-icon-right">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>
        </Link>
        <button onClick={onLogout} className="profile-nav-dropdown-item logout">
          <div className="item-icon-left">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
          </div>
          <span>Log Out</span>
        </button>
      </div>
    </div>
  );
}

export default ProfileNavDropdown;